export const TranslationOrigin = {
  BO: '',
  FO: '/fo'
} as const;

export type TranslationOrigin = (typeof TranslationOrigin)[keyof typeof TranslationOrigin];
